module.exports = "https://static.zego.com/_next/static/images/uber-nopad-02ee1e68da6b183ac81d30f29ada2d4c.svg";